import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import {
  componentLimit,
  lockComponents,
} from '../../../../configs/WidgetConfig';
import SimpleTooltip from '../../../common/tooltip/SimpleTooltip';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';
import { REDUCER_NAME, setDragPopup } from '../../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import QuickAccessPopup from './QuickAccessPopup';

class QuickAccess extends Component {
  state = {
    isShowPopup: false,
  };
  showRef = React.createRef();

  isDisable = ({ componentName }) => {
    const { countListComponent } = this.props;
    return (
      countListComponent[componentName] === 1 &&
      componentLimit[componentName] === 1
    );
  };

  renderActiveComponents = () => {
    const { quickComponents } = this.props;
    const components = [];
    quickComponents.forEach(component => {
      if (!component.isActive) {
        return;
      }
      const isDisabled = this.isDisable(component);
      const onClick = isDisabled ? null : () => this.onIconClick(component);
      const nameWithLang = I18n.t(
        `layout.quickAccess.${component.componentName}`,
      );
      const className = isDisabled
        ? 'disabled quick-access-item'
        : 'quick-access-item';
      const tooltipMessage = isDisabled
        ? I18n.t('layout.limitComponentMessage', {
            componentName: nameWithLang,
          })
        : nameWithLang;

      components.push(
        <SimpleTooltip
          key={component.componentName}
          position="bottom"
          message={tooltipMessage}
        >
          <div
            className={className}
            key={component.componentName}
            onClick={onClick}
          >
            <i className={`${component.icon}`} />
          </div>
        </SimpleTooltip>,
      );
    });

    return components;
  };

  onIconClick = component => {
    const { setDragPopup, user } = this.props;
    const isLock = lockComponents[component.componentName];
    if (isNotLoginOrExpired(user) && isLock) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    setDragPopup({
      isShow: true,
      ...component,
    });
  };

  showPopup = (bool = true) => {
    this.setState({
      isShowPopup: bool,
    });
  };

  toggleShow = () => {
    this.setState(prevState => ({
      isShowPopup: !prevState.isShowPopup,
    }));
  };

  render() {
    const { isShowPopup } = this.state;
    return (
      <div className="quick-ac-com mt-05 position-relative d-flex">
        {this.renderActiveComponents()}

        <div
          ref={this.showRef}
          onClick={this.toggleShow}
          className="more-quick-component quick-access-item"
        >
          <i className="icon-more" />
        </div>

        {isShowPopup && (
          <QuickAccessPopup showRef={this.showRef} showPopup={this.showPopup} />
        )}
      </div>
    );
  }
}

QuickAccess.propTypes = {
  quickComponents: PropTypes.array,
  setDragPopup: PropTypes.func.isRequired,
  countListComponent: PropTypes.object.isRequired,
};

QuickAccess.defaultProps = {
  quickComponents: [],
};

const mapStateToProps = state => ({
  quickComponents: state[REDUCER_NAME].quickComponents,
  countListComponent: state[COMMON_REDUCER_NAME].countListComponent,
  i18n: state.i18n,
  user: state.userInfo,
});

const mapDispatchToProps = {
  setDragPopup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickAccess);
